import { render, staticRenderFns } from "./MinimalInformationCampaignEdit.vue?vue&type=template&id=964bb6b2&"
import script from "./MinimalInformationCampaignEdit.vue?vue&type=script&lang=js&"
export * from "./MinimalInformationCampaignEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports